import {uniqueId} from 'lodash';
import React, {useEffect, useRef, useState} from 'react';

import {hasParticipantFilterActive} from '../../../../../data/filters/participantsFilters';
import {useElementRect} from '../useProtectedRegions';
import Categories from './filters/Categories';
import Favorites from './filters/Favorites';
import InnerFilter from './filters/InnerFilter';
import TextFilter from './filters/TextFilter';

const BubblesFilterState = props => {
    const {className = '', event, filterParams, onProtectRegion = () => {}} = props,
        hasActiveFilter = hasParticipantFilterActive(filterParams),
        ref = useRef(),
        rect = useElementRect(ref),
        [cid] = useState(uniqueId('c'));

    useEffect(() => onProtectRegion(cid, rect), [rect, onProtectRegion]);
    useEffect(() => () => onProtectRegion(cid, null), [onProtectRegion]);

    // console.log('DEV ', filterParams);

    return (
        <div ref={ref} className={className}>
            <InnerFilter event={event} filterParams={filterParams} />
            <Favorites event={event} filterParams={filterParams} />
            <Categories event={event} filterParams={filterParams} />
            <TextFilter event={event} filterParams={filterParams} />
        </div>
    );
};

export default BubblesFilterState;
